import { createContext, useContext } from "react";

/**
 * Signals to the shared profile section components (ProfileSidebar, InterviewsContent, …) that
 * they are being rendered inside the compact `ProfileModal` (the AI-review dashboard's profile
 * popup) rather than a full page. Used to hide the left sidebar (the modal has a top nav instead)
 * and, for the "Review AI Interview" launch, to show only the Technical interview panel.
 */
export interface ProfileModalCtx {
  inModal: boolean;
  /** Interviews section: show only the Technical panel (Behavioral + Revet hidden). */
  technicalOnly?: boolean;
}

export const ProfileModalContext = createContext<ProfileModalCtx | null>(null);

export function useProfileModal(): ProfileModalCtx | null {
  return useContext(ProfileModalContext);
}
